import { ListRange } from '../../../../../common/models/list.model';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { ShipmentWaybillSapDeliveriesState } from './shipment-waybill-sap-deliveries.state';
import { ShipmentWaybillSapDeliveriesStateModel } from './shipment-waybill-sap-deliveries.state';
import {
  ShipmentWaybillSapDeliveriesInitialState,
  ShipmentWaybillSapDeliveriesLoad,
} from './shipment-waybill-sap-deliveries.actions';
import { Injectable } from '@angular/core';
import { ShipmentSapDeliveryListSearchCriteria } from '../../../../../common/models';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';
import { WaybillIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillSapDeliveriesFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillSapDeliveriesState.getLoaded);
  listDto$: Observable<ShipmentWaybillSapDeliveriesStateModel> = this.store.select(
    ShipmentWaybillSapDeliveriesState.getState,
  );

  constructor(private store: Store, private shipmentWaybillItemFacade: ShipmentWaybillItemFacade) {}

  loadAll(listRange?: ListRange): void {
    this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$
      .pipe(take(1))
      .subscribe((waybillIdView: WaybillIdView) => {
        this.store.dispatch(
          new ShipmentWaybillSapDeliveriesLoad(
            new ShipmentSapDeliveryListSearchCriteria({ ...listRange, waybillIdView }),
          ),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillSapDeliveriesInitialState());
  }
}
